import React from 'react';
import NotFound from '../Components/NotFound';
import { Box, Button, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';

const PageNotFound = (props: {message?: String, backLink?: String, texttButton?: String}) => {
    const navigator = useNavigate();
    function redirect(){
        navigator(props.backLink? props.backLink+"" : "/")
    }
    return (
        <Box className={"notFound"} marginTop={"5%"}>
            <NotFound />
            <center><Typography variant='h4' color={"inherit"}>{props.message? props.message : "Page Not Found"}</Typography></center><br />
            <center><Button onClick={redirect}>{props.texttButton? props.texttButton : "Back to home"}</Button></center>
        </Box>
    );
};

export default PageNotFound;